import React from 'react'

class Footer extends React.Component {

    render() {
        return (
            <>
            </>
        )
    
    }

}

export default Footer